import { GroupItemKinds } from '@care/navigation/dist/components/GlobalNavIA/NavLinkList/NavLinkList';

/**
 *
 *  This function generates an array of common links for the "More Info" section
 *  of a navigation menu. It includes links for plans and pricing, safety center,
 *  and employer-sponsored benefits.
 *  @param baseURL - The base URL for the application.
 *  @returns An array of link objects, each containing href, id, kind, and value.
 */

export const getMoreInfoCommonLinks = (baseURL: string): GroupItemKinds[] => [
  {
    href: `${baseURL}/app/vhp/plans-and-pricing`,
    id: 'plans-and-pricing',
    kind: 'link',
    value: 'Plans & pricing',
  },
  {
    href: `${baseURL}/about/safety/`,
    id: 'safety-center',
    kind: 'link',
    value: 'Safety center',
  },
  {
    href: `${baseURL}/app/ent-enrollment/member-enrollment/welcome`,
    id: 'employer-sponsored-benefits',
    kind: 'link',
    value: 'Employer-sponsored benefits',
  },
];
